import styled, { css } from 'styled-components'

import { Box } from '../../../shared_components/UI/Box'

import { Link } from 'react-router-dom'
import { defaultTransition } from '../../../theme'

import { getRgbaValue } from '../../../utils/styling/getRgbaValue'

export const PoolButton = styled.button<{
  isUpcoming?: boolean
  narrowButton?: boolean
  secondary?: boolean
}>`
  width: ${({ narrowButton }) => (narrowButton ? '120px' : '100%')};
  height: 56px;
  left: 20px;
  top: 324px;
  background: ${({ theme }) => theme.colors.brandPrimary};
  color: black;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
  padding: 0px 32px;

  :hover {
    filter: brightness(0.8);
  }
  :disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
  ${({ secondary }) =>
    secondary &&
    css`
      background: ${({ theme }) => theme.colors.brandSecondary};
      color: white;
    `}
`

export const ChainLabelContainer = styled(Box)<{
  maxWidth?: number | null
}>`
  max-width: ${({ maxWidth }) => maxWidth ?? 178}px;
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100px;
  align-items: center;
  justify-content: flex-start;
  position: relative;
  padding-left: 24px;
  margin-left: 14px;
  @media screen and (max-width: 1000px) {
    margin-bottom: 16px;
  }
`

export const ChainTitle = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  padding-top: 1px;
  text-transform: uppercase;
  margin-left: 8px;
  color: ${(props) => props.theme.semantics.zap.surface.primary}; ;
`

export const IconAndChainContainer = styled(Box)`
  flex: 1;
  width: 100%;
  align-items: center;
  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
`

export const ChainIconNoBg = styled.img`
  margin-left: 6px;
  position: absolute;
  left: 0px;
  height: 20px;
  width: 20px;
  border-radius: 250px;
`

export const PoolTitle = styled.h1`
  font-weight: 1000;
  font-size: 72px;
  margin: 0;
  line-height: 1;
  font-family: Space Grotesk;
  letter-spacing: -0.04em;
  text-transform: uppercase;
  font-feature-settings: 'ordn' on, 'dnom' on, 'ss01' on;
  color: ${(props) => props.theme.semantics.zap.surface.primary};
  @media screen and (max-width: 767px) {
    font-size: 40px;
    line-height: 45px;
  }
`

export const BoxSubHeading = styled.span<{
  fullOpacity?: boolean
  isValue?: boolean
}>`
  color: #f6f8ff;
  font-feature-settings: 'ss01' on;
  -webkit-text-stroke-width: 1;
  -webkit-text-stroke-color: #f6f8ff;
  font-family: 'Space Grotesk';
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  opacity: ${({ fullOpacity }) => (fullOpacity ? 1 : 0.5)};
  ${({ isValue }) =>
    isValue &&
    css`
      color: #f6f8ff;
      text-align: right;
      font-feature-settings: 'ss01' on;
      font-family: 'Space Grotesk';
      font-size: 14px;
      font-style: normal;
      font-weight: 300;
      line-height: normal;
    `}
`

export const PoolTicker = styled.h4`
  font-style: normal;
  font-weight: normal;
  font-size: 22px;
  line-height: 25px;
  text-transform: uppercase;
  color: ${(props) => props.theme.semantics.zap.surface.primary};
  margin-bottom: 6px;
  margin-left: 8px;
`

export const OuterWrapper = styled.div`
  z-index: 10;
  position: relative;
  font-family: 'Space Grotesk';
  @media screen and (max-width: 767px) {
    padding-top: 32px;
  }
`

export const TopBanner = styled.div<{ bgImage?: string; top: number }>`
  position: relative;
  pointer-events: none;
  width: 100vw;

  z-index: 0;
  :before {
    content: '';
    position: absolute;
    ${defaultTransition}
    top: -${({ top }) => top}px;
    right: 0;
    bottom: 0;
    left: 0;
    height: 641px;
    background: linear-gradient(
      transparent,
      transparent 50%,
      ${(props) => props.theme.semantics.zap.surface.primary}
    );
    pointer-events: none;
    @media screen and (max-width: 1000px) {
      height: 400px;
    }
  }
  :after {
    position: absolute;
    content: '';
    pointer-events: none;
    ${defaultTransition}
    top: -${({ top }) => top}px;
    width: 100%;
    z-index: -2;
    height: 641px;
    background: url(${({ bgImage }) => bgImage});
    background-repeat: no-repeat;
    background-position: top center;
    background-size: cover;
    @media screen and (min-width: 600px) and (max-width: 1000px) {
      background-position: center;
      background-size: cover;
      height: 400px;
    }
    @media screen and (max-width: 600px) {
      background-position: center;
      background-size: cover;
      height: 400px;
    }
  }
`

export const ButtonWrapper = styled.div`
  max-width: 200px;
  @media screen and (max-width: 767px) {
    max-width: 95vw;
    grid-template-rows: 48px 48px !important;
    gap: 16px !important;
    margin-bottom: 32px !important;
    margin-top: 32px !important;
  }
`

export const TabToggleBarDesktop = styled.div`
  display: none;
  @media screen and (min-width: 767px) {
    display: flex;
  }
`

export const TabToggleBarMobile = styled.div`
  display: none;
  @media screen and (max-width: 767px) {
    margin-top: 0px;
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
  }
`

export const PeriodTitleContainer = styled.div`
  margin-left: calc(100% - 519px);
  @media screen and (max-width: 1230px) {
    margin-left: 0;
  }
`

export const PeriodTitle = styled.p<{ period?: string }>`
  font-size: 32px !important;
  line-height: 36px !important;
  text-transform: uppercase;
  margin-top: 8px;
  margin-bottom: 16px !important;
  color: ${({ period, theme }) =>
    period === 'upcoming'
      ? theme.colors.brandPrimary
      : period === 'open'
      ? theme.colors.brandSecondary
      : theme.colors.textPrimary};
`

export const SwapAmountLabel = styled.p`
  font-size: 16px;
  line-height: 18px;
  text-transform: uppercase;
  margin-top: 16px;
  color: ${(props) => props.theme.semantics.zap.surface.primary}; ;
`

export const SwapAmount = styled.p`
  font-size: 32px;
  line-height: 36px;
  margin-top: 8px;
  text-transform: uppercase;
`

export const ExhangeRate = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  opacity: 0.6;
  margin-top: -16px;
  margin-bottom: 16px;
`

export const TokenLogo = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 4px;
`

export const PoolAddress = styled.span`
  font-style: normal;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: 0.05em;
  opacity: 0.5;
  margin-top: 8px;
  font-family: Space Grotesk;
`

export const SwapBoxContainer = styled(Box)<{
  mobileSwipeOpen: boolean
  swipeOffset: number
  period: string
  hasScrolled: boolean
  hasTopBar: boolean
}>`
  z-index: 100;
  position: fixed;
  ${defaultTransition}
  @media screen and (min-width: 1000px) {
    max-width: 321px;
    top: ${({ hasScrolled, hasTopBar }) =>
      hasScrolled ? 32 : hasTopBar ? 264 : 216}px;
  }
  @media screen and (min-width: 1000px) and (max-width: 1400px) {
    left: calc((100vw - 32px - 340px));
  }
  @media screen and (min-width: 1400px) {
    left: calc((100vw - 1400px) / 2 + 1060px);
  }

  @supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: rgba(0, 0, 0, 0.8);
  }
`

export const SwapBox = styled(Box)<{
  mobileSwipeOpen: boolean
  swipeOffset: number
  period: string
  hasScrolled: boolean
}>`
  width: 340px;
  height: 100%;
  min-height: 300px;
  height: 100%;
  left: 0px;
  top: 0px;

  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  border-radius: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 0 : 4)}px;
  padding: 16px 16px 32px 16px;
  z-index: 1000;
  background: #353a40;

  clip-path: polygon(9% 0, 100% 0, 100% 94.5%, 91% 100%, 0 100%, 0 5.5%);

  &::after {
    content: '';
    position: absolute;
    background-color: rgba(0, 0, 0, 1);
    z-index: -1;
    clip-path: polygon(9% 0, 100% 0, 100% 94.5%, 91% 100%, 0 100%, 0 5.5%);
    top: 1.5px;
    left: 1.5px;
    border-radius: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 0 : 4)}px;
    right: 1.5px;
    bottom: 1.5px;
  }
  @media screen and (max-width: 1000px) {
    position: fixed;
    z-index: 100;
    transition: border-radius 0.9s ease-in-out, background 0.3s ease-in-out,
      top 0.6s ease-in-out,
      min-height 1.2s ease-in-out
        ${({ mobileSwipeOpen }) =>
          mobileSwipeOpen ? ', transform 0.6s ease-in-out' : ''};
    top: ${({ mobileSwipeOpen }) =>
      mobileSwipeOpen ? '0px' : `calc(100dvh - 92px)`};
    transform: translateY(${({ swipeOffset }) => swipeOffset}px);
    left: 0px;
    padding: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 16 : 32)}px;
    border: 1px solid
      ${({ mobileSwipeOpen, theme, period }) =>
        mobileSwipeOpen
          ? 'transparent'
          : getRgbaValue(
              period === 'upcoming'
                ? theme.colors.brandPrimary
                : theme.colors.brandPrimary,
              0.8,
            )};
    min-height: ${({ mobileSwipeOpen }) =>
      mobileSwipeOpen ? '100vh' : '200px'};
    width: 100vw;
    z-index: 100;
    background: ${({ mobileSwipeOpen, theme, period }) =>
      mobileSwipeOpen
        ? 'transparent'
        : getRgbaValue(
            period === 'upcoming'
              ? theme.colors.brandPrimary
              : theme.colors.brandPrimary,
            0.8,
          )};
    @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
      -webkit-backdrop-filter: blur(
        ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 50 : 4)}px
      );
      backdrop-filter: blur(
        ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 50 : 4)}px
      );
    }
  }
`

export const SwapInner = styled(Box)<{ mobileSwipeOpen: boolean }>`
  margin: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? '8px 8px' : '0px')};
  padding: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 32 : 0)}px;
  transition-delay: 0.3s;
  height: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? '100vh' : 'auto')};
  border: 1px solid
    ${({ mobileSwipeOpen, theme }) =>
      !mobileSwipeOpen ? 'transparent' : theme.colors.lowOpacityBorder};
  border-radius: 18px;
`

export const DismissButton = styled.button<{
  mobileSwipeOpen: boolean
  isStaking?: boolean
}>`
  position: absolute;
  right: ${({ isStaking }) => (isStaking ? 16 : 40)}px;
  top: ${({ isStaking }) => (isStaking ? 20 : 40)}px;
  z-index: 12;
  height: 32px;
  width: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 1 : 0)};
`

export const DragBar = styled(Box)<{ mobileSwipeOpen: boolean }>`
  width: 100%;
  position: relative;
  min-height: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 32 : 90)}px;
  height: 200px;
  margin-top: -32px;
  z-index: 11;
  opacity: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 0 : 1)};
  ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 'max-height: 32px;' : '')};
  @media screen and (min-width: 1000px) {
    display: none;
  }
`

export const DragBarInner = styled.div<{ isStaking?: boolean }>`
  width: 60px;
  height: 4px;
  background-color: rgba(0, 0, 0, 0.6);
  margin-top: 4px;
  border-radius: 2px;
  ${({ isStaking }) => isStaking && 'position: absolute;top: 24px;'}
`

export const TopWrapper = styled(Box)`
  z-index: 10;
  flex: 0;
  @media screen and (max-width: 500px) {
    justify-content: flex-start;
    align-items: flex-start;
  }
`

export const PriceBox = styled(Box)`
  width: auto;
  height: 30px;
  padding: 8px 16px;
  background: ${({ theme }) => theme.colors.swapBoxPriceLabelBg};

  border-radius: 4px;
  margin: 16px 0 16px;
  span {
    font-style: normal;
    font-weight: 500;
    font-size: 11px;
    line-height: 12px;
    text-transform: uppercase;
  }
  @media screen and (min-width: 1000px) {
    margin: -8px 0 0;
  }
`

export const DetailButton = styled.button<{ noHover?: boolean }>`
  margin-top: 32px;
  border: 1px solid ${(props) => props.theme.colors.lowOpacityBorder};
  box-sizing: border-box;
  margin-right: 8px;
  padding: 12px 16px;
  border-radius: 40px;
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 15px;
  font-family: Space Grotesk;
  display: flex;
  cursor: ${({ noHover }) =>
    typeof noHover !== 'undefined'
      ? noHover
        ? 'default'
        : 'pointer'
      : 'pointer'};
  @media screen and (max-width: 1000px) {
    width: auto;
  }
`

export const PageToggler = styled(Box)`
  width: 100%;
  z-index: 9;
  width: calc(100% - 420px);
  margin: 40px 0 64px;
  flex: 0;
  @media screen and (max-width: 1000px) {
    width: 100%;
    margin: 32px 0;
    padding-bottom: 16px;
  }
`

export const PageLink = styled(Link)<{ $isActive: boolean }>`
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
  position: relative;
  text-align: center;
  margin-top: 11px;
  letter-spacing: -0.01em;
  text-transform: uppercase;
  color: ${(props) => props.theme.semantics.zap.surface.primary};
  margin-right: 32px;
  ${defaultTransition}
  opacity: ${({ $isActive }) => ($isActive ? 1 : 0.3)};
  :hover {
    opacity: ${({ $isActive }) => ($isActive ? 0.8 : 0.5)};
    ::after {
      opacity: ${({ $isActive }) => ($isActive ? 0.8 : 0.5)};
    }
  }
  ::after {
    content: '';
    position: absolute;
    bottom: -17px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: ${(props) => props.theme.semantics.zap.surface.primary};
    opacity: ${({ $isActive }) => ($isActive ? 1 : 0)};
  }

  @media screen and (max-width: 1000px) {
    /* min-width: 500px; */
    font-size: 14px;
  }
`

export const TablesWrapper = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  width: 100%;
  text-transform: uppercase;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`

export const TableTitle = styled.h4`
  font-size: 24px;
  line-height: 30px;
  font-weight: normal;
  font-family: Space Grotesk;
  letter-spacing: 1px;
  margin: 16px 0 48px;
`

export const TableWrapper = styled.div`
  flex: 1;
  margin: 16px 0 32px;
  margin-right: 16px;
  width: 100%;

  @media screen and (max-width: 1200px) {
    min-width: 100%;
    div {
      min-width: 75%;
    }
  }
`

export const RecordContainer = styled.div`
  flex: 1;
  margin: 25px 0;
  width: 100%;
  p {
    width: 50%;
    font-family: Space Grotesk;
    font-style: normal;
    font-weight: 300;
    font-size: 16px;
    line-height: 32px;
  }
  &::before {
    content: '';
    position: absolute;
    bottom: -14px;
    width: 100%;
    height: 2px;
    background: rgba(196, 196, 196, 0.5);
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
    padding: 8px 0;
    p {
      width: 100%;
    }
  }
`

export const RecordTitle = styled.p`
  flex: 2;
`

export const TopTitle = styled.span`
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.1em;
  color: black !important;
  opacity: 0.6;
  margin-top: -8px;
  margin-bottom: 4px;
`

export const PeriodTitleSwipe = styled.span`
  font-family: Space Grotesk;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 30px;
  text-transform: uppercase;
  color: #000000;
  /* identical to box height */
`

export const MobilePeriodContainer = styled(Box)<{
  mobileSwipeOpen: boolean
}>`
  display: ${({ mobileSwipeOpen }) => (mobileSwipeOpen ? 'none' : 'flex')};
  flex-direction: column;
  position: absolute;
  @media screen and (min-width: 1000px) {
    display: none;
  }
`

export const DesktopPeriodContainer = styled(Box)<{ period: string }>`
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  min-height: 54px;
  border-top-right-radius: 6px;
  width: calc(100% + 34px);
  margin-left: -17px;
  margin-top: -17px;
  background: ${({ period, theme }) =>
    period === 'completed'
      ? getRgbaValue(theme.colors.brandPrimary, 1)
      : getRgbaValue(theme.colors.brandPrimary, 1)};
  @media screen and (max-width: 1000px) {
    display: none;
  }
`

export const SubscribeContainer = styled(Box)`
  margin-top: 8px;
  flex-direction: column;
`

export const PoolInput = styled.input<{
  isSmall?: boolean
}>`
  width: 100%;
  height: 56px;
  padding: 8px;
  background: ${({ theme }) => theme.colors.poolInputBg};
  border: 1px solid rgba(255, 255, 255, 0.5);
  box-sizing: border-box;
  border-radius: 8px;
  outline: none;
  font-family: Space Grotesk;
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  position: relative;
  ::placeholder {
    opacity: ${({ theme: { isDark } }) => (isDark ? 0.3 : 0.8)};
  }
  ${({ isSmall }) =>
    isSmall &&
    css`
      max-width: 160px;
      font-size: 18px;
      @media screen and (max-width: 1000px) {
        max-width: 100%;
      }
    `}
`

export const PeriodCaption = styled.span`
  overflow: hidden;
  color: #030c12;
  text-align: center;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 157.143% */
`

export const PeriodTimer = styled.span<{ period: string }>`
  /* identical to box height, or 75% */
  margin-bottom: 4px;
  overflow: hidden;
  color: #030c12;
  text-align: center;
  font-feature-settings: 'ss01' on;
  text-overflow: ellipsis;
  font-family: 'Space Grotesk';
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 16px; /* 133.333% */
  letter-spacing: 3.6px;
  text-transform: uppercase;
`

export const CurrencyLabel = styled.span`
  font-size: 14px;
  opacity: 1;
`

export const ConnectWalletButton = styled.h4`
  cursor: pointer;
  margin: 16px 0 24px;
`

export const BarWrapper = styled(Box)`
  width: 100%;
  margin-top: 16px;
  @media screen and (max-width: 600px) {
    width: 100%;
  }
`

export const SwapPct = styled.span`
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  text-align: right;
  letter-spacing: 0.05em;
`

export const MobileColumn = styled(Box)`
  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
`

export const LoadingContainer = styled(Box)`
  min-height: calc(100vh - 400px);
`
